import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ContractDocument.Save.IRequest;
type Response = Api.Core.ContractDocument.Save.IResponse;
type Headers = Api.Core.ContractDocument.Save.IHeaders;
const url = '/api/Sales/Contract/:id/Documents';
export default async function contractDocumentSaveApi(body?: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { id: body?.contractId }),
    body,
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
